import { useState, useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Sort from './Sort'
import { getAppIndex, getSortIndex } from '../../functions/getAlgoliaIndex'

import SortByIcon from '../../assets/SortByIcon.svg'
import CancelIcon from '../../assets/CancelIcon.svg'
import icons from '../../assets/BuildIcons/Icons'
import './Sort.scss'

const CustomSortBy = () => {
  const win = window
  const localhost = win.location.hostname === 'localhost'
  const [showSort, setShowSort] = useState(false)
  const { t } = useTranslation()
  const { popular, asc, desc, newer } = getSortIndex()

  function useOutsideAlerter(ref: any) {
    useEffect(() => {
      function handleClickOutside(event: any) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowSort(false)
        }
      }
      document.addEventListener('mousedown', handleClickOutside)
      return () => {
        document.removeEventListener('mousedown', handleClickOutside)
      }
    }, [ref])
  }

  const wrapperRef = useRef(null)
  useOutsideAlerter(wrapperRef)

  return (
    <>
      {showSort && <div className="mobileCustomSort_backDrop" />}
      <div ref={wrapperRef}>
        <div className="mobileCustomSort">
          <span>
            <button
              className="sortButton"
              style={{ border: 'none', backgroundColor: 'white' }}
              onClick={() => setShowSort(!showSort)}
            >
              <div className="mobileSortBy">
                <img
                  src={localhost ? SortByIcon : icons.sortByIcon}
                  alt="sortByIcon"
                />
                <span className="mobileSortLabel">{t('sort_by')}</span>
              </div>
            </button>
          </span>
        </div>
        <div
          className="mobileSortOptions"
          style={{ display: showSort ? 'block' : 'none' }}
          onClick={() => {
            setShowSort(!showSort)
          }}
        >
          <div className="mobileSortOptionsTitle">{t('sort_by')}</div>
          <div
            className="sortCancel"
            onClick={() => {
              setShowSort(false)
            }}
          >
            <img
              src={localhost ? CancelIcon : icons.cancelIcon}
              alt="cancelIcon"
            />
          </div>
          <Sort
            defaultRefinement={getAppIndex()}
            items={[
              { value: popular, label: t('popular') },
              {
                value: asc,
                label: t('price_low_to_high'),
              },
              {
                value: desc,
                label: t('price_high_to_low'),
              },
              {
                value: newer,
                label: t('newer'),
              },
            ]}
          />
        </div>
      </div>
    </>
  )
}

export default CustomSortBy
